import type { WorkoutSession, WorkoutTemplate } from "./types";

export function startOfLocalDay(timestamp: number) {
  const date = new Date(timestamp);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

export function startOfLocalWeek(timestamp: number) {
  const date = new Date(startOfLocalDay(timestamp));
  const dayFromMonday = (date.getDay() + 6) % 7;
  date.setDate(date.getDate() - dayFromMonday);
  return date.getTime();
}

export function localWeekDays(timestamp: number) {
  const monday = new Date(startOfLocalWeek(timestamp));
  return Array.from({ length: 7 }, (_, index) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + index);
    return day.getTime();
  });
}

export function isSameLocalDay(left: number, right: number) {
  return startOfLocalDay(left) === startOfLocalDay(right);
}

export function sessionsInLocalWeek(sessions: WorkoutSession[], timestamp: number) {
  const start = startOfLocalWeek(timestamp);
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  return sessions
    .filter((session) => session.startedAt >= start && session.startedAt < end.getTime())
    .sort((left, right) => left.startedAt - right.startedAt);
}

export function nextTemplateInRotation(templates: WorkoutTemplate[], sessions: WorkoutSession[]) {
  if (!templates.length) return undefined;
  const templateIds = new Set(templates.map((template) => template.id));
  const lastCompleted = sessions
    .filter((session) => session.status === "completed" && templateIds.has(session.workoutTemplateId))
    .sort((left, right) => right.startedAt - left.startedAt)[0];
  if (!lastCompleted) return templates[0];
  const lastIndex = templates.findIndex((template) => template.id === lastCompleted.workoutTemplateId);
  return templates[(lastIndex + 1) % templates.length];
}
